// Traduções para veículos - Português (Brasil)
export const vehiclesPt = {
  // Página de veículos
  page: {
    title: 'Veículos',
    found: 'veículos encontrados',
    searchPlaceholder: 'Buscar por marca, modelo ou ano...',
    noResults: 'Nenhum veículo encontrado',
    noResultsDescription: 'Tente ajustar os filtros ou critérios de busca',
    orderBy: 'Ordenar por',
    showMore: 'Ver mais',
  },

  // Detalhes do veículo
  details: {
    loading: 'Carregando detalhes do veículo...',
    notFound: 'Veículo não encontrado',
    backToVehicles: 'Voltar para veículos',
    specifications: 'Especificações',
    features: 'Características',
    contact: 'Tenho interesse neste veículo',
    description: 'Descrição',
  },

  // Filtros
  filters: {
    title: 'Filtros',
    clearFilters: 'Limpar filtros',
    applyFilters: 'Aplicar filtros',
    close: 'Fechar filtros',
    showMore: 'Ver mais',
    showLess: 'Ver menos',
    priceRange: 'Faixa de preço',
    minPrice: 'Preço mínimo',
    maxPrice: 'Preço máximo',
    selectBrand: 'Selecione uma marca',
    brand: 'Marca',
    model: 'Modelo',
    category: 'Categoria',
    year: 'Ano',
    fuelType: 'Tipo de combustível',
    condition: 'Condição',
    color: 'Cor',
    mileage: 'Quilometragem',
    dealership: 'Loja',
    facturable: 'Nota fiscal', // BR: "Facturable" (factura chilena) → nota fiscal
    facturableYes: 'Com nota fiscal', // BR: factura → nota fiscal
    facturableNo: 'Sem nota fiscal', // BR: factura → nota fiscal
    facturableHint:
      'Os veículos com nota fiscal são vendidos com os impostos destacados, assim a empresa pode aproveitar o crédito fiscal.', // BR: "afectos a IVA" → "com os impostos destacados" (neutro, sem IVA)
    transmission: 'Câmbio',
    transmissionManual: 'Manual',
    transmissionAutomatic: 'Automático',
    traction: 'Tração',
    traction4x2: '4x2',
    traction4x4: '4x4',
    tractionAwd: 'AWD (integral)',
    tractionFwd: 'FWD (dianteira)',
  },

  // Categorias
  categories: {
    all: 'Todos os Veículos',
    suv: 'SUV',
    sedan: 'Sedã',
    hatchback: 'Hatch',
    pickup: 'Picape',
    camioneta: 'Caminhonete',
    van: 'Van',
    coupe: 'Cupê',
    wagon: 'Perua',
    trabajo: 'Veículos de trabalho',
  },
  categoryDescriptions: {
    all: 'Explore todos os nossos veículos disponíveis',
    suv: 'Veículos espaçosos e versáteis',
    sedan: 'Carros familiares confortáveis',
    hatchback: 'Compactos e econômicos',
    pickup: 'Veículos de carga e trabalho',
    camioneta: 'Caminhonetes de trabalho e cabine dupla',
    van: 'Veículos espaçosos para passageiros',
    coupe: 'Elegantes e esportivos',
    wagon: 'Veículos familiares versáteis',
    trabajo: 'Caminhonetes e veículos para trabalho pesado',
  },

  // Ordenação
  sorting: {
    dateDesc: 'Mais recentes primeiro',
    dateAsc: 'Mais antigos primeiro',
    priceAsc: 'Preço: Menor para Maior',
    priceDesc: 'Preço: Maior para Menor',
    yearDesc: 'Ano: Mais Recente',
    yearAsc: 'Ano: Mais Antigo',
    mileageAsc: 'Quilometragem: Menor para Maior',
    mileageDesc: 'Quilometragem: Maior para Menor',
  },

  // Card do veículo
  card: {
    year: 'Ano',
    mileage: 'Quilometragem',
    price: 'Preço',
    viewDetails: 'Ver detalhes',
    contact: 'Entrar em contato',
    reserved: 'Reservado',
    sold: 'Vendido',
    features: 'Características',
    fuel: 'Combustível',
    transmission: 'Câmbio',
    color: 'Cor',
  },

  // Status
  status: {
    available: 'Disponível',
    reserved: 'Reservado',
    sold: 'Vendido',
    pending: 'Pendente',
  },
};
